<template>
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.027 3v6M3.028 6h6M1 .5h10c.277 0 .5.223.5.5v10c0 .277-.223.5-.5.5H1a.499.499 0 0 1-.5-.5V1C.5.723.723.5 1 .5Z" fill="#fff" stroke="#c4c4c4" stroke-linecap="round"/>
  </svg>
</template>
